import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('Choose a Category');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name: string, url: string) => {
    setSelectedLabel(name);
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="w-full px-6 md:px-10 py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-sm font-medium text-foreground-600 tracking-wider uppercase mb-3">
          Quick Navigation
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">
          Browse Product Categories
        </h2>
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-background-100 border border-background-300/60 rounded-xl text-foreground-800 text-sm cursor-pointer hover:border-primary-300 transition-colors"
          >
            <span>{selectedLabel}</span>
            <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-lg"></i>
            </span>
          </button>

          {isOpen && (
            <div className="absolute left-0 right-0 top-full mt-2 bg-background-50 border border-background-200/70 rounded-xl shadow-lg z-40 max-h-72 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat.name, cat.url)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer first:rounded-t-xl last:rounded-b-xl"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className={`${cat.icon} text-base`}></i>
                  </span>
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}